// extracted by mini-css-extract-plugin
var _1 = "AIButtonTextGrey-moduleaiButtonTextGrey__mVWNT AIButtonText-moduleaiButtonText__hhww0";
var _2 = "AIButtonTextGrey-moduleaiButtonTextGreyLabel__Qp_aK AIButtonText-moduleaiButtonTextLabel__UEafF";
var _3 = "AIButtonTextGrey-moduleloading__tNtuV";
export { _1 as "aiButtonTextGrey", _2 as "aiButtonTextGreyLabel", _3 as "loading" }
